import { render, staticRenderFns } from "./InStoreBookingConfirmation.vue?vue&type=template&id=2ee36f32&scoped=true"
import script from "./InStoreBookingConfirmation.vue?vue&type=script&lang=js"
export * from "./InStoreBookingConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee36f32",
  null
  
)

export default component.exports